import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import config from '../config';
import axios from 'axios';

const Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if already authenticated
    axios.get(`${config.api.baseUrl}/me`, { withCredentials: true })
      .then(() => {
        navigate('/assignments');
      })
      .catch(() => {
        // Not authenticated, stay on landing page
      });
  }, [navigate]);

  const handleGoogleLogin = () => {
    window.location.href = config.api.auth.google;
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <Typography variant="h3" component="h1" gutterBottom>
          Welcome to Varos
        </Typography>
        
        <Typography variant="h6" component="h2" textAlign="center" color="text.secondary">
          Manage your assignments and tasks efficiently
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={handleGoogleLogin}
          startIcon={<GoogleIcon />}
          sx={{
            mt: 3,
            backgroundColor: '#4285F4',
            '&:hover': {
              backgroundColor: '#357ABD',
            },
          }}
        >
          Sign in with Google
        </Button>
      </Box>
    </Container>
  );
};

export default Landing; 